export default {
  // Search section
  searchPlaceholder: 'Please enter model name',
  searchButton: 'Search',
  addModel: 'Add Model',

  // Modal titles
  editModelTitle: 'Edit Model',
  uploadModelTitle: 'Upload Model',

  // Form fields
  modelNameField: 'Model Name',
  modelNamePlaceholder: 'Please enter model name',
  modelLabelField: 'Model Label',
  modelLabelPlaceholder: 'Please select model label',
  modelTypeField: 'Model Type',
  modelTypePlaceholder: 'Please select model type',
  largeModel: 'Large Model',
  smallModel: 'Small Model',
  versionField: 'Version',
  versionPlaceholder: 'Please enter version number, e.g.: 1.0',
  statusField: 'Status',
  statusPlaceholder: 'Please select status',
  normal: 'Normal',
  stopped: 'Stopped',
  modelFileField: 'Model File',
  selectModelFile: 'Select Model File',

  // Table columns
  modelName: 'Model Name',
  versionNumber: 'Version Number',
  recentTrainingTime: 'Recent Training Time',
  onlineTime: 'Online Time',
  modelStatus: 'Model Status',
  modelLabel: 'Model Label',
  deployStatus: 'Deploy Status',
  createTime: 'Creation Time',
  operation: 'Operation',

  // Status values
  running: 'Running',
  alreadyStopped: 'Stopped',
  separator: '---',

  // Action buttons
  deleteModel: 'Delete Model',
  deleteContainer: 'Delete Container',
  stopContainer: 'Stop Container',
  deploy: 'Deploy',
  edit: 'Edit',

  // Buttons
  cancel: 'Cancel',
  confirm: 'Confirm',

  // Validation messages
  modelNameRequired: 'Please enter model name',
  modelLabelRequired: 'Please select model label',
  versionRequired: 'Please enter version number',
  modelTypeRequired: 'Please select model type',
  statusRequired: 'Please select status',
  selectModelFileRequired: 'Please select model file',

  // Messages
  modelUpdateSuccess: 'Model updated successfully',
  modelUploadSuccess: 'Model uploaded successfully',
  deploySuccess: 'Deployed successfully',
  deployFailed: 'Deployment failed',
  containerDeleteSuccess: 'Container deleted successfully',
  containerDeleteFailed: 'Container deletion failed',
  deleteSuccess: 'Deleted successfully',
  deleteFailed: 'Deletion failed',
  containerStopSuccess: 'Container stopped successfully',
  containerStopFailed: 'Container stop failed',
  uploadFailed: 'Upload failed',
  updateFailed: 'Update failed',

  // Confirmation dialogs
  confirmDeployTitle: 'Confirm Deploy',
  confirmDeployContent: 'Are you sure you want to deploy model {name}?',
  confirmDeleteContainerTitle: 'Confirm Delete Container',
  confirmDeleteContainerContent: 'Are you sure you want to delete the container for model "{name}"?',
  confirmDeleteModelTitle: 'Confirm Delete Model',
  confirmDeleteModelContent: 'Are you sure you want to delete model {name}?',
  confirmStopContainerTitle: 'Confirm Stop Container',
  confirmStopContainerContent: 'Are you sure you want to stop the container for model "{name}"?',
}
